// wallet-standard-tx.ts - web3.js-dependent (de)serialization for the Wallet
// Standard `solana:signTransaction` / `solana:signAndSendTransaction` features,
// which exchange raw transaction BYTES. Split into its own module so
// wallet-standard-discovery.ts can lazy-import it only when a transaction is
// actually signed, keeping wallet listing + SIWS message login off the heavy
// @solana/web3.js chunk. Mirrors the wire helpers in
// @solana-mobile/mobile-wallet-adapter-protocol-web3js.
import { Transaction, VersionedTransaction, VersionedMessage, } from "@solana/web3.js";
const ED25519_SIGNATURE_LENGTH = 64;
/** Serialize an unsigned Transaction/VersionedTransaction to the wire bytes the
 *  wallet-standard sign features expect (legacy skips signature verification). */
export function serializeUnsignedTx(tx) {
    if ("version" in tx)
        return tx.serialize();
    return tx.serialize({ requireAllSignatures: false, verifySignatures: false });
}
/** Deserialize the signed bytes a wallet returns, round-tripping legacy or
 *  versioned transactions correctly. */
export function deserializeSignedTx(bytes) {
    const messageOffset = bytes[0] * ED25519_SIGNATURE_LENGTH + 1;
    const version = VersionedMessage.deserializeMessageVersion(bytes.slice(messageOffset, bytes.length));
    return version === "legacy" ? Transaction.from(bytes) : VersionedTransaction.deserialize(bytes);
}
